import React, { useState, useEffect } from "react";
import "./BackgroundController.css";

// Import background images
import bg1 from "../assets/bg01.png";
import bg2 from "../assets/bg02.png";
import bg3 from "../assets/bg03.png";
import bg4 from "../assets/bg04.png";

// Import corresponding sounds
import sound1 from "../assets/subway.wav";
import sound2 from "../assets/street.wav";
import sound3 from "../assets/office.wav";
import sound4 from "../assets/cafe.wav";

import { Image, SpeakerHigh } from "@phosphor-icons/react";

// Array of images & corresponding sounds
const backgrounds = [
    {title: "On the subway", image: bg1, sound: sound1 },
    {title: "On a stroll", image: bg2, sound: sound2 },
    {title: "In the office", image: bg3, sound: sound3 },
    {title: "At a coffeeshop", image: bg4, sound: sound4 }
];

const BackgroundController = () => {
    const [bgIndex, setBgIndex] = useState(0);
    const [isSoundOn, setIsSoundOn] = useState(false);
    const [audio, setAudio] = useState(new Audio(backgrounds[bgIndex].sound));

    // Handle cycling background images & updating sound
    const cycleBackground = () => {
        const nextIndex = (bgIndex + 1) % backgrounds.length;
        setBgIndex(nextIndex);
    };

    // Handle sound toggle
    const toggleSound = () => {
        if (isSoundOn) {
            audio.pause();
        } else {
            audio.loop = true;
            audio.volume = 0.5;
            audio.play();
        }
        setIsSoundOn(!isSoundOn);
    };

    // Update sound when background changes
    useEffect(() => {
        audio.pause(); // Stop previous sound
        const newAudio = new Audio(backgrounds[bgIndex].sound);
        setAudio(newAudio);
        if (isSoundOn) {
            newAudio.loop = true;
            newAudio.volume = 0.5;
            newAudio.play();
        }
    }, [bgIndex]);

    return (
        <>
            {/* Background container */}
            <div 
                className="background-container"
                style={{ backgroundImage: `url(${backgrounds[bgIndex].image})` }}
            ></div>

            {/* Top Right Buttons */}
            <div className="top-right-buttons">
                <button className="button commute" onClick={cycleBackground}>
                    <Image/>
                    {backgrounds[bgIndex].title}
                </button>
                <button className="button sound" onClick={toggleSound}>
                    <SpeakerHigh/>
                    Sound: {isSoundOn ? "On" : "Off"}
                </button>
            </div>
        </>
    );
};

export default BackgroundController;
